import { h, Component } from "preact";
import { route } from "preact-router";

import PFeed from "../../../services/prematch-feed";
import LFeed from "../../../services/live-feed";
import Page from "../../../services/page-data-feed";
import User from "../../../services/user";
import Ticket from "../../jamibet/utils/ticket-logic";
import formatOdd from "../../../services/odds-format";

import * as P from "../../jamibet/mobile-templates/sports";
import * as I from "../../jamibet/utils/icons";
import { RegionFlagIcon } from "../../jamibet/desktop-templates/prematch-menu.jsx";

import { WidgetEventsCarouselContent } from "../home-lite/event-widget.jsx";
import PrematchCarousel from "../../jamibet/desktop-components/prematch-carousel";
import SchedulesTimeFilter from "../../jamibet/utils/schedules-time-filter";

import AwrabetMobilePageHome, {
	MobileLastMinute as AwrabetMobileLastMinute,
	MobileLiveEvents as AwrabetMobileLiveEvents,
	MobileMostPlayed as AwrabetMobileMostPlayed,
	MobileTopLeagues as AwrabetMobileTopLeagues,
	WithPrematch as AwrabetWithPrematch,
} from "../../awrabet/mobile-pages/home";

import { MarketingEvents } from "../../../utils/gtm-module";
import FullSite from "./full-site";
import { LiveEventsBadge, WithPrematch } from "../../jamibet/mobile-pages/home";
import { PaddedContainer } from "../../jamibet/mobile-templates/general";
import { FeaturedCasinoGames } from "../../harifsport/mobile-pages/home";
import CashoutService from "../../../services/cashout";

// Sezione home "lite" (palette awrabet/koba), dalla barra filtri in giù.
import * as PLite from "../home-lite/templates-sports.jsx";
import { FakeSeparator } from "../home-lite/templates-tournament.jsx";
import { SearchComponent } from "../home-lite/prematch.jsx";
import MenuTimeFilterComponent from "../home-lite/menu-time-filter.jsx";
import { MobileTopLeagues, MobileTopWidget, MobileLiveEvents } from "../home-lite/home-sections.jsx";

export default class MobilePageHome extends AwrabetMobilePageHome {
	state = {
		openBetsCount: 0
	};

	componentDidMount() {
		if (User.isLogged()) {
			CashoutService.fetchOpenBets().then(bets => {
				this.setState({ openBetsCount: bets.length });
			}).catch(() => {
				this.setState({ openBetsCount: 0 });
			});
		}
	}

	render() {
		const sortedSportsList = PFeed.menu ? Object.values(PFeed.menu).sort((a, b) => a.order - b.order) : null;
		const { openBetsCount } = this.state;
		return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit">
			<P.SportsHolder>
				<P.SportLikeButton onClick={e => window.location.href += '#betslip'}>
					<P.SportIconBox><I.TicketIcon class="h-6 -rotate-45" /></P.SportIconBox>
					<P.SportName>Check Bet</P.SportName>
				</P.SportLikeButton>
				{User.isLogged() && <P.SportLikeButton onClick={e => route('/cashout')}>
					<P.SportIconBox>
						<I.UserIcon class="h-full text-amber-500" />
						<span class="block absolute -top-1.5 -right-2 text-xs">{openBetsCount}</span>
					</P.SportIconBox>
					<P.SportName>My Bets</P.SportName>
				</P.SportLikeButton>}
				<P.SportLikeButton onClick={e => route('/live')}>
					<P.SportIconBox>
						<I.LiveIcon class="h-full" />
						{!LFeed.menu ? null : <LiveEventsBadge />}
					</P.SportIconBox>
					<P.SportName>Live</P.SportName>
				</P.SportLikeButton>
				{sortedSportsList && sortedSportsList
					.filter(s => SchedulesTimeFilter.isScheduleAllowed(s))
					.map(sport => {
						return <P.SportButton sport={sport} onClick={e => route('/prematch/' + sport.id.split('/')[2])} />
					})
				}
			</P.SportsHolder>
			{/* Casino nascosto dalla home (richiesta cliente). NON rimuovere l'import/riferimento:
			    serve a tenere il chunk dinamico del casino nel grafo, altrimenti la build Parcel
			    fallisce con "bundleInfoMap[bundleId] is not iterable". */}
			{false && <FeaturedCasinoGames />}
			<div class="bg-gojjo-lite-200 text-gojjo-lite-950">
				<div class="aspect-1865/380 w-full">
					<PrematchCarousel />
				</div>
				<PaddedContainer>
					<WidgetEventsCarouselContent />
				</PaddedContainer>
				<PLite.HeaderContainer>
					<MenuTimeFilterComponent />
					<SearchComponent />
				</PLite.HeaderContainer>
				<MobileTopLeagues />
				<FakeSeparator />
				<WithPrematch><MobileTopWidget /></WithPrematch>
				<WithPrematch><MobileLiveEvents /></WithPrematch>
			</div>
		</FullSite>
	}
}
